import React from 'react';
import { Button } from './ui/button';
import { Link } from "react-router-dom";
import LocaleModal from "@/components/LocaleModal";
import { Separator } from '@radix-ui/react-select';
import { Globe, Key, Loader, Sparkles } from "lucide-react";

function LabelFooter() {
  return (

<footer className="fixed bottom-0 left-0 w-full h-12 bg-background/80 p-2 font-sans z-30 backdrop-blur-xl border-t-2 border-white/40 grid grid-cols-[1fr_auto_1fr] items-center">

{/* Empty spacer */}
<div />

{/* Center label */}

<p className="flex items-center text-center font-sans  tracking-widest text-black/60 font-medium text-sm">
  {/* Made in Rotterdam */}
  <Loader className='w-4 h-4 mr-2'/>
  Crafted in The Netherlands{/* Gemaeckt in de Nederlanden */}
{/*   <span
    aria-label="Flag of the Netherlands"
    role="img"
    className="inline-block h-5 w-7 overflow-hidden ml-2 align-middle relative bottom-[2px]"
  >
    <span className="block rounded-t-sm h-1/3 w-full bg-[#f52a2a]" />
    <span className="block h-1/3 w-full bg-white" />
    <span className="block rounded-b-sm h-1/3 w-full bg-[#376ed3]" />
  </span> */}
  {/* {"\n"}& London */}

</p>

{/* Right side */}
{/* <div className="flex justify-end">
  <LocaleModal
    trigger={
      <Button className="bg-transparent rounded-2xl hover:bg-white/60 h-fit text-black/60 hover:text-black">
        <Globe className="w-4 h-4 mr-2" />
        EN
      </Button>
    }
    onApply={({ region }) => {
      window.location.pathname = `/${region}`;
    }}
  />
</div> */}

</footer>

  );
}

export default LabelFooter;
